import Map from './Map';

/**/
const CLASS_MARKER: string = 'marker';

Map.registerPlugin(
	'InfoBox',
	() => class InfoBox extends google.maps.OverlayView
	{
		private options: InfoBoxOptions;
		
		private element: HTMLElement;
		private size: google.maps.Size;
		private ltMargin: google.maps.Size;
		private textAlign: string;
		private offsetTop: number;
		private isMarker: boolean;
		
		public constructor( options?: InfoBoxOptions )
		{
			super();
			
			this.setDefault();
			
			if ( options )
			{
				this.setOptions( options );
			}
		}
		/*public constructor( name: string )
		{
			super();
			console.log( this, name );
		}*/
		
		public sayHello(): void
		{
			//console.log( 'Hello!' );
		}
		
		public getContent(): string|Node
		{
			return this.options.content;
		}
		
		public getPosition(): google.maps.LatLng
		{
			return this.options.position;
		}
		
		public getZIndex(): number
		{
			return this.options.zIndex;
		}
		
		public setContent( content: string|Node ): void
		{
			this.options.content = content;
		}
		
		public setPosition( position: google.maps.LatLng ): void
		{
			this.options.position = position;
		}
		
		public setZIndex( zIndex: number ): void
		{
			this.options.zIndex = zIndex;
		}
		
		public setTextAlign( textAlign: string ): void
		{
			this.textAlign = textAlign;
		}
		
		public setOffsetTop( offset: number ): void
		{
			this.offsetTop = offset;
		}
		
		public addClass( className: string ): void
		{
			this.element.classList.add( className );
		}
		
		public removeClass( className: string ): void
		{
			this.element.classList.remove( className );
		}
		
		public hasClass( className: string ): boolean
		{
			return this.element.classList.contains( className );
		}
		
		public onAdd(): void
		{
			var panes: google.maps.MapPanes;
			panes = this.getPanes();
			
			if ( !panes )
			{
				return;
			}
			
			if ( !this.element )
			{
				this.create();
			}
			
			panes.floatPane.appendChild( this.element );
			
			this.size = new google.maps.Size(
				this.element.offsetWidth,
				this.element.offsetHeight
			);
			
			this.ltMargin = new google.maps.Size(
				parseInt( this.element.style.marginLeft ),
				parseInt( this.element.style.marginTop )
			);
			 
			if ( !this.options.disableAutoPan )
			{
				this.panMap();
			}
			
			//super.onAdd();
		}
		
		public draw(): void
		{
			var pixelPosition: google.maps.Point;
			
			pixelPosition = this.getProjection().fromLatLngToDivPixel( <google.maps.LatLng>this.options.position );
			
			if ( !pixelPosition )
			{
				return;
			}
			
			if ( this.options.pixelOffset === null )
			{
				this.options.pixelOffset = new google.maps.Size( 0, 0 );
			}
			
			//this.element.style.top = ( pixelPosition.y - this.options.pixelOffset.height - this.size.height * 1.5 ).toString() + 'px';
			this.element.style.top = ( pixelPosition.y - this.options.pixelOffset.height - this.size.height * 1.5 - this.offsetTop ).toString() + 'px';
			this.element.style.left = ( pixelPosition.x + this.options.pixelOffset.width - this.size.width / 2 ).toString() + 'px';
			
			this.element.style.textAlign = this.textAlign;
			
			//super.draw();
		}
		
		public onRemove(): void
		{
			this.element.remove();
		}
		
		public open( map: google.maps.Map, anchor?: google.maps.Marker|google.maps.LatLng ): void
		{
			if ( anchor )
			{
				if ( anchor instanceof google.maps.Marker )
				{
					this.isMarker = true;
					
					if ( typeof anchor.getPosition === "function" )
					{
						this.options.position = anchor.getPosition();
					}
				}
				else if ( anchor instanceof google.maps.LatLng )
				{
					this.options.position = anchor;
				}
				else
				{
					this.options.position = null;
				}
			}
			
			if ( this.options.position instanceof google.maps.LatLng )
			{
				this.setMap( map );
			}
		}
		 
		public close(): void
		{
			this.setMap( null );
		}
		
		private setDefault(): void
		{
			this.options = {};
			
			this.options.content = '';
			this.options.disableAutoPan = false;
			this.options.maxWidth = 0;
			this.options.pixelOffset = null;
			this.options.position = null;
			this.options.zIndex = 0;
			
			this.element = null;
			this.size = null;
			this.ltMargin = null;
			this.textAlign = 'left';
			this.offsetTop = 0;
			this.isMarker = false;
		}
		 
		private setOptions( options: google.maps.InfoWindowOptions ): void
		{
			//var key: any;
			//
			//for ( key in options )
			//{
				//if ( options.hasOwnProperty( key ) )
				//{
					//if ( options[key] )
					//{
						//console.log( 'key: ' + key + ', options[key]: ' + options[key] );
						//this.options[key] = options[key];
					//}
				//}
			//}
		
			if ( options.content )
			{
				this.options.content = options.content;
			}
			
			if ( options.disableAutoPan )
			{
				this.options.disableAutoPan = options.disableAutoPan;
			}
			
			if ( options.maxWidth )
			{
				this.options.maxWidth = options.maxWidth;
			}
			
			if ( options.pixelOffset )
			{
				this.options.pixelOffset = options.pixelOffset;
			}
			
			if ( options.position )
			{
				this.options.position = <google.maps.LatLng>options.position;
			}
			
			if ( options.zIndex )
			{
				this.options.zIndex = options.zIndex;
			}
		}
		 
		private create(): void
		{
			if ( !this.element )
			{
				var element: HTMLElement;
				var content: HTMLElement;
				
				element = document.createElement( 'div' );
				element.classList.add( 'info-box' );
				element.addEventListener( 'click', this.elementClickHandler.bind( this ), false );
				
				if ( !this.isMarker )
				{
					var close: HTMLButtonElement;
					
					close = document.createElement( 'button' );
					close.classList.add( 'close' );
					close.type = 'button';
					element.appendChild( close );
					close.addEventListener( 'click', this.buttonCloseClickHandler.bind( this ), false );
				}
				
				content = document.createElement( 'div' );
				content.classList.add( 'content' );
				element.appendChild( content );
				
				document.addEventListener( 'keyup', this.documentKeyupHandler.bind( this ), false );
				//document.addEventListener( 'keyup.infobox', this.documentKeyupHandler, false );
				
				if ( this.options.maxWidth > 0 )
				{
					element.style.maxWidth = this.options.maxWidth.toString() + 'px';
				}
				
				if ( this.options.zIndex !== 0 )
				{
					element.style.zIndex = this.options.zIndex.toString();
				}
				
				element.addEventListener( 'mousedown', this.elementMouseDownHandler.bind( this ), false );
				
				this.element = element;
				content.innerHTML = this.options.content.toString();
				
				if ( this.isMarker )
				{
					this.addClass( CLASS_MARKER );
				}
			}
		}
		
		private panMap(): void
		{
			var map: google.maps.Map;
			var bounds: google.maps.LatLngBounds;
			var margin: number;
			
			var mapElement: HTMLElement;
			var boundsSpan: google.maps.LatLng;
			var degPixelX: number;
			var degPixelY: number;
			
			var position: google.maps.LatLng;
			var pixelOffset: google.maps.Size;
			
			var boxWestLng: number;
			var boxEastLng: number;
			var boxNorthLat: number;
			var boxSouthLat: number;
			
			var mapWestLng: number;
			var mapEastLng: number;
			var mapNorthLat: number;
			var mapSouthLat: number;
			
			var shiftLng: number;
			var shiftLat: number;
			
			var center: google.maps.LatLng;
			
			map = <google.maps.Map>super.getMap();
			
			if ( !map || !this.element )
			{
				return;
			}
			
			bounds = map.getBounds();
			
			if ( !bounds )
			{
				return;
			}
			
			margin = 20;
			
			mapElement = <HTMLElement>map.getDiv();
			boundsSpan = bounds.toSpan();
			degPixelX = boundsSpan.lng() / mapElement.offsetWidth;
			degPixelY = boundsSpan.lat() / mapElement.offsetHeight;
			
			if ( this.options.pixelOffset === null )
			{
				this.options.pixelOffset = new google.maps.Size( 0, 0 );
			}
			
			position = this.options.position;
			pixelOffset = this.options.pixelOffset;
			
			boxWestLng = position.lng() + (pixelOffset.width + this.ltMargin.width - margin)
					* degPixelX;
			boxEastLng = position.lng() + (pixelOffset.width + this.ltMargin.width + this.size.width + margin)
					* degPixelX;
			boxNorthLat = position.lat() + (pixelOffset.height - this.ltMargin.height + this.size.height + margin)
					* degPixelY;
			boxSouthLat = position.lat() + (pixelOffset.height - this.ltMargin.height - margin)
					* degPixelY;
			
			mapWestLng = bounds.getSouthWest().lng();
			mapEastLng = bounds.getNorthEast().lng();
			mapNorthLat = bounds.getNorthEast().lat();
			mapSouthLat = bounds.getSouthWest().lat();
			
			shiftLng = ( boxWestLng < mapWestLng ? mapWestLng - boxWestLng : 0 )
					+ ( boxEastLng > mapEastLng ? mapEastLng - boxEastLng : 0 );
			shiftLat = ( boxNorthLat > mapNorthLat ? mapNorthLat - boxNorthLat : 0 )
					+ ( boxSouthLat < mapSouthLat ? mapSouthLat - boxSouthLat : 0 );
			
			center = map.getCenter();
			
			map.setCenter(
				new google.maps.LatLng(
					center.lat() - shiftLat,
					center.lng() - shiftLng
				)
			);
		}
		
		private documentKeyupHandler( event: KeyboardEvent ): void
		{
			if ( event.which === 27 )
			{
				this.close();
			}
		}
		
		private elementClickHandler( event: MouseEvent ): void
		{
			event.stopImmediatePropagation();
			event.stopPropagation();
			
			this.close();
		}
		
		private elementMouseDownHandler( event: MouseEvent ): void
		{
			event.stopPropagation();
		}
		
		private buttonCloseClickHandler( event: MouseEvent ): void
		{
			this.close();
		}
	}
);

interface InfoBoxOptions
{
	content?: string|Node;
	disableAutoPan?: boolean;
	maxWidth?: number;
	pixelOffset?: google.maps.Size;
	position?: google.maps.LatLng;
	zIndex?: number;
}

interface InfoBoxInterface extends google.maps.OverlayView
{
	new (): InfoBoxInterface;
	getContent(): string|Node;
	getPosition(): google.maps.LatLng;
	getZIndex(): number;
	setContent( content: string|Node ): void;
	setPosition( position: google.maps.LatLng ): void;
	setZIndex( zIndex: number ): void;
	setTextAlign( textAlign: string ): void;
	setOffsetTop( offset: number ): void;
	addClass( className: string ): void;
	removeClass( className: string ): void;
	hasClass( className: string ): boolean;
	onAdd(): void;
	draw(): void;
	onRemove(): void;
	open( map: google.maps.Map, anchor?: google.maps.Marker|google.maps.LatLng ): void;
	close(): void;
	
	sayHello(): void;
}

export {InfoBoxInterface as default};
